import { FC, useState } from "react";

import { ConfirmActionModal } from "src/components/Modal";
import { useT } from "src/internationalization";

export type ConfirmPageReloadModalProps = {
  onClose: () => void;
};

export const ConfirmPageReloadModal: FC<ConfirmPageReloadModalProps> = ({ onClose }) => {
  const t = useT();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = () => {
    setIsLoading(true);
    /* We need to wait 3 seconds before reloading because when updating schemaClient,
     * the server needs time to restart. If we reload too quickly, we'll get a 502 error.
     * This delay ensures the server has enough time to complete its restart process.
     */
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  return (
    <ConfirmActionModal
      size="sm"
      title={t("header.switcher.settings.schema.reload.title")}
      onClose={onClose}
      onConfirm={handleConfirm}
      confirmButtonText={t("general.actions.confirm")}
      loading={isLoading}
    >
      {t("header.switcher.settings.schema.reload.message")}
    </ConfirmActionModal>
  );
};
